var _excluded = ["sources", "alt", "src", "ratio", "position", "video", "smartImageProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, Fragment } from 'react';
import PropTypes, { string, number } from 'prop-types';
import { Picture, VideoButton, Iframe } from './style';
import Icon from '../Icon';
import Box from '../Box';
import * as icons from '../Icons';
import SmartImage from '../SmartImage';
var Image = function Image(_ref) {
  var sources = _ref.sources,
    alt = _ref.alt,
    src = _ref.src,
    ratio = _ref.ratio,
    position = _ref.position,
    video = _ref.video,
    smartImageProps = _ref.smartImageProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    play = _useState2[0],
    setPlay = _useState2[1];
  var playVideo = function playVideo() {
    setPlay(!play);
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Picture, _extends({}, otherProps, {
    ratio: ratio,
    video: video
  }), sources.map(function (source) {
    return /*#__PURE__*/React.createElement("source", _extends({}, source, {
      key: source.srcSet
    }));
  }), /*#__PURE__*/React.createElement(SmartImage, _extends({
    alt: alt,
    src: src,
    ratio: ratio,
    position: position
  }, smartImageProps))), video.src && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(VideoButton, {
    id: video.buttonStyle,
    onClick: playVideo,
    variant: video.buttonStyle,
    text: video.buttonText,
    stretch: "auto",
    leftIcon: /*#__PURE__*/React.createElement(Icon, {
      as: icons.PlayIcon
    })
  }), play && /*#__PURE__*/React.createElement(Iframe, {
    src: "".concat(video.src, "?autoplay=1"),
    frameborder: "0",
    allowfullscreen: true
  })));
};
Image.propTypes = {
  alt: string,
  /** Only affects if image is cropped */
  position: string,
  /** Width / height. If null keeps original ratio. */
  ratio: number,
  src: string.isRequired,
  sources: PropTypes.arrayOf(PropTypes.shape({
    srcSet: string.isRequired,
    media: string,
    sizes: string,
    type: string
  })),
  video: PropTypes.shape({
    src: string,
    buttonText: string,
    buttonStyle: string
  }),
  smartImageProps: PropTypes.shape({
    sizedSrcList: PropTypes.arrayOf(PropTypes.shape({
      size: PropTypes.number,
      url: PropTypes.string,
      type: PropTypes.string
    }))
  })
};
Image.defaultProps = {
  alt: '',
  position: null,
  ratio: null,
  sources: [],
  video: {},
  smartImageProps: {}
};
export default Image;